export default "__VITE_ASSET__a44b0d00__"